import { useEffect } from 'react';
import { Outlet, Route, Routes, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import './App.scss';
import OauthFailed from './components/login/OauthFailed';
import { useModal } from './components/modal/ModalContext';
import { CosmosEventProvider } from './helpers/cosmosHelper';
import { useOauthHelper } from './helpers/login/oauthHelper';
import Badges from './pages/badges/Badges';
import MintProvider from './pages/events/event/mint/MintNftProvider';
import Home from './pages/home/Home';
import Identity from './pages/identity/Identity';
import Invite from './pages/invite/Invite';
import NotFound404 from './pages/NotFound404';
import ReferralHandler from './pages/ReferralHandler';
import Xion from './pages/xion/xion';
import AllTasks from './pages/allTask/AllTasks';

// import { Abstraxion } from '@burnt-labs/abstraxion';
// import EventAnalytics from "./pages/admin/eventAnalytics/EventAnalytics";

export const AppProvider = () => {
  const [{ openModal }] = useModal();
  const oauthHelper = useOauthHelper();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const init = async () => {
      const oauthData = searchParams?.get('oauthData');
      const postLoginAction = searchParams?.get('action');
      const oauthError = searchParams?.get('error');

      if (oauthData) {
        try {
          await oauthHelper.getLoginCookies(oauthData);
        } catch (e) {}
      }

      if (oauthData || postLoginAction || oauthError) navigate(location?.pathname, true);

      if (oauthError)
        openModal({
          className: 'oauthFailed-container',
          content: <OauthFailed oauthError={oauthError} />,
        });
    };

    init().catch(e => {});
  }, []);

  return (
    <div className='App'>
      <CosmosEventProvider>
        <MintProvider>
          <Xion>
            <Outlet />
          </Xion>
        </MintProvider>
      </CosmosEventProvider>
    </div>
  );
};

const App = () => {
  return (
    <Routes>
      <Route element={<AppProvider />}>
        <Route path='/' element={<Home />} />
        <Route path='/identity' element={<Identity />} />
        {/* <Route path='/programs' element={<Programs />} /> */}
        <Route path='/badges' element={<Badges />} />
        <Route path='/invite' element={<Invite />} />
        <Route path='/keys' element={<AllTasks />} />
        <Route path='/r/:referralCode' element={<ReferralHandler />} />
        <Route path='*' element={<NotFound404 />} />
      </Route>
    </Routes>
  );
};

export default App;
